import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../UI/Button";
const Logout = () => {
  const [loggedOut, setLoggedOut] = useState("You have been logged out");
  const navigate = useNavigate();

  const goBack = () => {
    // navigate("/login", { replace: true });

    window.location.href = "/login";
  };
  const style = {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    flexDirection: "column",
  };
  return (
    <section style={style}>
      <h1 style={style}>{loggedOut}</h1>
      <br />
      <div className="flexGrow">
        <Button value="Login Again" click={goBack} />
      </div>
    </section>
  );
};

export default Logout;
